import PlayStoreBadgeLink from './PlayStoreBadgeLink';

export default PlayStoreBadgeLink;
